// Small per-browser flags, kept both as a first-party cookie and in localStorage; either one is enough.
// Safari caps both at 7 days without a visit when they're written by script, so returning Safari
// shoppers may occasionally see an offer again.

const ONE_YEAR_SECONDS = 31536000;

export const SUBSCRIBED_FLAG = "km_subscribed";
export const LEAD_DISMISSED_FLAG = "km_lead_dismissed";
export const HAS_ORDERED_FLAG = "km_has_ordered";

function readCookie(name) {
  try {
    const match = document.cookie.split("; ").find((part) => part.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.slice(name.length + 1)) : "";
  } catch {
    return "";
  }
}

export function hasFlag(name) {
  if (readCookie(name) === "true") return true;
  try {
    return localStorage.getItem(name) === "true";
  } catch {
    return false;
  }
}

export function setFlag(name) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  try {
    document.cookie = `${name}=true; max-age=${ONE_YEAR_SECONDS}; path=/; SameSite=Lax${secure}`;
  } catch {
    // cookies blocked: localStorage below may still work
  }
  try {
    localStorage.setItem(name, "true");
  } catch {
    // storage blocked: the flag lasts for this page view only
  }
}

